<template>
  <footer class="footer">
    <div class="wrapper footer__wrapper">
      <div class="footer__top">
        <ul class="footer__nav">
          <li class="footer__navitem">
            <div class="footer__item">
              <a href="mailto:info@retailprodigygroup.com" class="footer__link" target="_blank">
              Contact Us
            </a>
            </div>
            <div class="footer__item">
              <a href="mailto:info@retailprodigygroup.com" class="footer__text" target="_blank">
              info@retailprodigygroup.com
            </a>
            </div>
          </li>
          <li class="footer__navitem">
            <router-link
              to="/participating-nike-stores"
              class="footer__link"
            >
              Participating Nike Stores
            </router-link>
          </li>
          <li class="footer__navitem">
            <router-link
              to="/terms-conditions"
              class="footer__link"
            >
              Terms And Conditions
            </router-link>
          </li>
          <li class="footer__navitem">
            <router-link
              to="/terms-conditions"
              class="footer__link"
            >
              Privacy Policy
            </router-link>
          </li>
          <li class="footer__navitem">
            <a href="" class="footer__link" target="_blank">
              Unsubscribe
            </a>
          </li>
        </ul>
        <div class="footer__logo">
          <a href="https://www.nike.com/au/en_gb/" class="logo logo--footer" aria-label="Nike.com home" title="Click to go to Nike.com home">
            <Swoosh class="icon-logo icon-logo--footer" />
          </a>
        </div>
      </div>
      <div class="footer__bottom">
        &copy;{{ new Date().getFullYear() }} Retail Prodigy Group Pty Ltd. All Rights Reserved.
      </div>
    </div>
  </footer>
</template>

<script>
// @ is an alias to /src
import Swoosh from '@/assets/icons/swoosh.svg';

export default {
  name: 'Footer',
  components: {
    Swoosh,
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "@/assets/scss/settings.scss";

$footer-background: $charcoal-light;
$footer-text-color: $white;
$footer-link-color: $white;
$footer-link-hover-color: $white;
$footer-copyright: $grey;
$footer-border: #4a4a4a;

$footer-gap: $spacing;
$footer-padding: $spacing-double + 3px;
$footer-nav-gap: $spacing-double;
$footer-nav-gap-s: 25px;
$footer-nav-gap-f: -45px;
$footer-nav-gap-f-s: -65px;
$footer-height: 150px;
$footer-text: $grey-light;

.footer {
  background: $footer-background;
  color: $footer-text-color;
}

.footer__top {
  @include medium-up {
    display: flex;
    // height: $footer-height;
    flex-wrap: nowrap;
    align-items: flex-start;
    justify-content: space-between;
  }
}

.footer__nav {
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;

  @include medium-up {
    display: flex;
    flex-wrap: wrap;
  }
}

.footer__navitem {
  @include medium-up {
    // margin-right: $footer-nav-gap-s;
    margin-right: $footer-nav-gap;
    margin-bottom: $footer-gap;
    text-align: left;
  }

  // @include large-up {
  //   margin-right: $footer-nav-gap;
  // }

  // &:first-child {
  //   @include medium-up {
  //     margin-right: $footer-nav-gap-f-s;
  //   }

  //   @include large-up {
  //     margin-right: $footer-nav-gap-f;
  //   }
  // }

  & + .footer__navitem {
    margin-top: $footer-gap;

    @include medium-up {
      margin-top: 0;
    }
  }
}

.footer__item {
  & + .footer__item {
    margin-top: $spacing-half;
  }
}

.footer__link {
  text-decoration: none;
  color: $footer-link-color;
  font-size: 14px;
  font-weight: 500;

  &:hover,
  &:focus {
    color: $footer-link-hover-color;
  }
}

.footer__text {
  color: $footer-text;
  font-size: 14px;
}

a.footer__text {
  text-decoration: none;

  &:hover,
  &:focus {
    color: $footer-text;
    text-decoration: underline;
  }
}

.footer__logo {
  padding: $footer-padding 0;
  text-align: center;

  @include medium-up {
    padding: 0 0 $footer-padding;
    text-align: right;
  }
}

.icon-logo--footer {
  path {
    fill: $footer-text-color;
  }
}

.footer__bottom {
  padding-top: $spacing-half;
  border-top: 1px solid $footer-border;
  color: $footer-copyright;
  font-size: $body-font-size-copyright;
  line-height: $body-line-height-copyright;
  text-align: center;

  @include medium-up {
    text-align: left;
  }
}
</style>
